import { render, staticRenderFns } from "./deliveryRecordList.vue?vue&type=template&id=53dcd965&scoped=true"
import script from "./deliveryRecordList.vue?vue&type=script&lang=js"
export * from "./deliveryRecordList.vue?vue&type=script&lang=js"
import style0 from "./deliveryRecordList.vue?vue&type=style&index=0&id=53dcd965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcd965",
  null
  
)

export default component.exports